import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import moment from 'moment';

import LibraryControlReviewAction from '../../actions/library_control_review';
import * as types from '../../constants'

import './library_control_review_modal.css'


const LibraryControlReviewModal = (props) => {
  const [reviews, setReviews] = useState(props.library_control_review.library_control_reviews)

  useEffect(()=>{
    handleLibraryControlReviewActions()
  }, [props.library_control_review.action_type])

  const handleLibraryControlReviewActions = () => {
    switch (props.library_control_review.action_type){
      case types.GET_LIBRARY_CONTROL_REVIEWS.success:
        return setReviews(props.library_control_review.library_control_reviews);
      case types.LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED.success:
        return props.getLibraryControlReviews(props.plan_id);
      default: return;
    }
  }

  const markAsReviewed = (evt) => {
    const review_ids = [ parseInt(evt.target.dataset.review_id, 10) ]
    props.markLibraryControlReviewsAsReviewed(review_ids)
  }

  const markAllAsReviewed = () => {
    let review_ids = reviews.map(({ id }) => id);
    props.markLibraryControlReviewsAsReviewed(review_ids)
  }

  return (
    <Draggable handle=".library-control-reviews-header">
      <div className="library-control-reviews">
        <div className="library-control-reviews-header">
          <i className="delete icon" onClick={ props.onClose }></i>
          <a className="mark-as-reviewed" onClick={ markAllAsReviewed }>Mark all as reviewed</a>
          <div id="library-control-reviews-instructions">Review changes to library controls</div>
        </div>
        <div className="library-control-reviews-content">
          {
            reviews.length > 0 ?
            <table className="table library-control-reviews-table">
              <thead>
                <tr>
                  <th className="date-header">Date</th>
                  <th className="description-header">Description</th>
                  <th className="actions-header"></th>
                </tr>
              </thead>
              <tbody>
                {
                  reviews.map((review, index)=>{
                    return (
                      <tr>
                        <td>{ moment(review.created_at).format("DD MMM YYYY hh:mm A") }</td>
                        <td>{ review.description }</td>
                        <td><a className="mark-as-reviewed" data-review_id={review.id} onClick={ markAsReviewed }>Mark as reviewed</a></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            :
            <span>No reviews found.</span>
          }
        </div>
      </div>
    </Draggable>
  );
}

const mapStateToProps = (state) => {
  return {
    library_control_review: state.library_control_review
  }
}

const mapDispatchToProps = (dispatch) => {
  const libraryControlReviewAction = new LibraryControlReviewAction();

  return {
    getLibraryControlReviews: (plan_id) => {
      dispatch(libraryControlReviewAction.getLibraryControlReviews(plan_id))
    },
    markLibraryControlReviewsAsReviewed: (review_ids) => {
      dispatch(libraryControlReviewAction.markLibraryControlReviewsAsReviewed(review_ids))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LibraryControlReviewModal);



// WEBPACK FOOTER //
// ./src/views/library_control_review/library_control_review_modal.js